//I18n
import Translate from '../../i18n/Translate';

//Intersection
import { useInView } from "react-intersection-observer";


const Mission = () => {

    const [title, inView] = useInView({
        triggerOnce: true,
        threshold: .2
    });

    return (

        <section className="incoming-about__mission">

            <h2 className={`title animate slide-right ${inView ? 'in-view': ''}`} ref={title}>
                <Translate langkey="about.mission.title" />
            </h2>

            <div className="copy">

                <h3>
                    <Translate langkey="about.mission.subtitle1" />
                </h3>
                <p>
                    <Translate langkey="about.mission.copy1" />
                </p>

                <h3>
                    <Translate langkey="about.mission.subtitle2" />
                </h3>
                <p>
                    <Translate langkey="about.mission.copy2" />
                </p>

                <h3>
                    <Translate langkey="about.mission.subtitle3" />
                </h3>
                <p>
                    <Translate langkey="about.mission.copy3" />
                </p>
            </div>
        </section>
    )
}

export default Mission